/**
 * Centralized react-query mutation keys.
 *
 * Mirrors the favorite-plans actions exposed by the dashboard table (use / edit /
 * delete) plus the create performed while quoting. Using stable keys lets us track
 * mutation state and wire optimistic updates / invalidations consistently.
 */
export const MUTATION_KEYS = {
    favoritePlans: {
        create: ['favorite-plans', 'create'],
        update: ['favorite-plans', 'update'],
        delete: ['favorite-plans', 'delete'],
        use: ['favorite-plans', 'use'],
        premiumTable: ['favorite-plans', 'premium-table'],
    },
};

export default MUTATION_KEYS;
